import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";

import { getApiHeaders } from "../auth/authProvider";
import { currentEnvironment, IEnvironment } from "../utils/environment";

const rawBaseQuery = (baseUrl: string) =>
  fetchBaseQuery({
    baseUrl,
    prepareHeaders: async () => {
      const headers = await getApiHeaders();
      headers?.delete("Content-type"); // We want to be able to override
      return headers;
    },
  });

export type TDSFetchArgs = FetchArgs & {
  environment?: IEnvironment;
};

export const baseQuery: BaseQueryFn<TDSFetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  const baseUrl = args.environment ? args.environment.baseUrl : currentEnvironment().baseUrl;

  return rawBaseQuery(baseUrl)(args, api, extraOptions);
};
